module.exports = __webpack_public_path__ + "static/favicon-46c1a9ed4eb17897da46568c2442c45d.ico";